import React from "react";
// import LoginForm from "../Common/component/LoginForm";
import LoginPage from "../Common/component/LoginPage";

export default function login() {
  return (
    <section className="loginMainSection">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center align-items-center">
            {/* <LoginForm /> */}
            <LoginPage />
          </div>
        </div>
      </div>
    </section>
  );
}
